import React from 'react';
import { Grid } from '@mui/material';
import DocumentListVault from '../../document-vault/components/document-list-vault/DocumentListVault';
import { CustomersCategoryContent } from './CustomerCategoryContent';
import { ProgressOverlay } from '../../../common/progress-overlay/ProgressOverlay';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { RootState } from '../../../store';
import DocumentsBlock, {
  DocumentsActionsProps,
} from '../../../common/documents-block/DocumentsBlock';

interface DocumentsTabsProps {
  documents: any[];
  key: string;
  cardView?: boolean;
  workflow?: string | null;
  setWorkflow?: React.SetStateAction<any>;
  showWorkflowBreadcrumbs?: boolean;
  setShowWorkflowBreadcrumbs?: React.SetStateAction<any>;
  /** Pagination + card / list switcher, attached to the documents table / workflow cards. */
  documentsActions?: DocumentsActionsProps;
}

const DocumentsTabs: React.FC<DocumentsTabsProps> = ({
  documents,
  cardView,
  workflow,
  setWorkflow,
  setShowWorkflowBreadcrumbs,
  showWorkflowBreadcrumbs,
  documentsActions,
}) => {
  // useEffect(() => {
  //   const fetchAllDocuments = async () => {
  //     // For every member, dispatch both actions and wait for both results
  //     const results = await Promise.all(
  //       company.members.map(async (member) => {
  //         console.log('Member:', member);
  //         const [docsAction, contractsAction] = await Promise.all([
  //           dispatch(fetchDocuments({ data: { user: member.id, category: 'employment' } })),
  //           dispatch(fetchDocumentContracts({ data: { user: member.id, category: 'employment' } })),
  //         ]);
  //         // Assuming the payloads contain the resulting documents/objects
  //         return [
  //           ...(Array.isArray(docsAction.payload) ? docsAction.payload : []),
  //           ...(Array.isArray(contractsAction.payload) ? contractsAction.payload : []),
  //         ];
  //       })
  //     );
  //     const filteredDocuments = results
  //       .flat()
  //       .filter((doc) => doc.employees?.includes(employee.id));
  //     setDocuments(filteredDocuments);
  //   };

  //   fetchAllDocuments();
  // }, [company.members, dispatch, documentContracts, documentUploads]);

  const documentUploadsLoading = useAppSelector((state: RootState) => state.documents.status);

  return (
    <Grid component='div' container wrap='nowrap'>
      <Grid component='div' size={{ xs: 12 }}>
        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <FilterDrawer sections={filterSections} onApplyFilters={handleApplyFilters} />
        </Box> */}
        {cardView ? (
          <CustomersCategoryContent
            documents={documents}
            workflow={workflow}
            setWorkflow={setWorkflow}
            showWorkflowBreadcrumbs={showWorkflowBreadcrumbs}
            cardView={cardView}
            documentsActions={documentsActions}
            setShowWorkflowBreadcrumbs={setShowWorkflowBreadcrumbs}
          />
        ) : (
          <DocumentsBlock actions={documentsActions}>
            <DocumentListVault documents={documents} compact embedded={!!documentsActions} />
            {documentUploadsLoading === 'loading' && <ProgressOverlay position='absolute' />}
          </DocumentsBlock>
        )}
      </Grid>
    </Grid>
  );
};

export default DocumentsTabs;
